export const RESET = 'EXCMUSERDATASTATUS_UPDATE_RESET'
export const SET_ERROR = 'EXCMUSERDATASTATUS_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXCMUSERDATASTATUS_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXCMUSERDATASTATUS_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXCMUSERDATASTATUS_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXCMUSERDATASTATUS_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXCMUSERDATASTATUS_UPDATE_UPDATE_RETRIEVED'
